export const mutations = {
    setUser (state, payload) {
      state.user = payload
    },
    setUserData (state, payload) {
      state.userData = payload
    },
    setAffiliate (state, payload) {
      state.affiliate = payload
    },
    setUid (state, payload) {
      state.uid = payload
    },
    setRegisId (state, payload) {
      state.regisId = payload
    },
    setEmail (state, payload) {
      state.email = payload
    },
    setError (state, payload) {
      state.error = payload
    },
    setLoading (state, payload) {
      state.loading = payload
    },
    setSuccess (state, payload) {
      state.success = payload
    },
    setLayout (state, payload) {
      state.layout = payload
    },
    setInsureCompany (state, payload) {
      state.insureCompany = payload
    },
    setAgents(state, payload) {
      state.agents = payload
    },
    set_personDB(state, objDB){
       state.person = objDB
    },
    set_incomeDB(state, objDB){
      state.income = objDB
   },
   set_allincomeDB(state, objDB){
    state.incomeall = objDB
 },


  }



// WEBPACK FOOTER //
// ./src/store/mutations.js